import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'
import './plugins/vue-world-map'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import axios from 'axios'

Vue.config.productionTip = false
//test
//axios.defaults.baseURL='https://localhost:22573'
//test 20222
//azure
//axios.defaults.baseURL='https://flexymaxapi.azurewebsites.net/'
//sun
axios.defaults.baseURL='https://api.latam-ia.com'
//axios.defaults.baseURL='http://192.168.100.30:9494'
new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
